import requests from "./httpService";

const SroServices = {
    // Get all SRO records
    getAllSro: async () => {
        return requests.get(`/sro`);
    },

    // Get single SRO record by ID
    getSroById: async (id) => {
        return requests.get(`/sro/${id}`);
    },

    // Create new SRO record
    createSro: async (data) => {
        return requests.post(`/sro`, data);
    },

    // Update SRO record
    updateSro: async (id, data) => {
        return requests.patch(`/sro/${id}`, data);
    },

    // Delete SRO record
    deleteSro: async (id) => {
        return requests.delete(`/sro/${id}`);
    },

    // Get SRO by district code
    getSroByDistrictCode: async (districtCode) => {
        return requests.get(`/sro/district/${districtCode}`);
    }
}

export default SroServices;